export const parseActivityLogTitle = (actor: string, action: string) =>
  `Timesheet ${action} by ${actor}`;

export const formatDuration = (totalMins: number): string => {
  if (totalMins === 0) return `0h`;
  const hours = Math.trunc(totalMins / 60);
  const mins = totalMins % 60;
  return `${hours}h ${mins}m`;
};
